import key from 'weak-key';

// styles
import styles from './picto.module.scss';

// components
import { Title } from '../Title/Title';
import { PictoItem } from './picto-item/picto-item';

// utils
import { TitleFormats } from '../Title/title.types';
import { useSectionId } from 'utils/hooks/use-section-id';
import { isEmpty } from 'utils/is-empty';

type Item = {
  description: string;
  headline: string;
  image: string;
  imageAlt: string;
  imageObject: ImageObject;
  imageObjectMobile: ImageObject;
  previewId: string;
};

type PictoProps = {
  title: string;
  titleInAnchor: boolean;
  contentIndex: number;
  subtitle?: string;
  anchor?: string;
  items?: Item[];
  border?: string;
  reducedMobileVersion?: boolean;
  isSectionReference?: boolean;
  isChild?: boolean;
};

export function Picto({
  title,
  anchor,
  subtitle,
  items,
  border,
  contentIndex,
  titleInAnchor,
  reducedMobileVersion,
  isSectionReference,
  isChild,
}: Readonly<PictoProps>) {
  const sectionId = useSectionId(title, anchor ?? '', titleInAnchor, contentIndex);
  const borderClass = border ? styles.disableBorder : '';

  if (isEmpty(items)) return null;

  return (
    <div className="grid-container">
      <div className={`${styles.picto} ${borderClass}`} id={sectionId}>
        <Title
          title={title}
          subtitle={subtitle}
          Format={isChild ? TitleFormats.h4 : TitleFormats.h2}
          titlePreviewId="#st_title"
          subtitlePreviewId="#st_subtitle"
          isSectionReference={isSectionReference}
          formatClassName="h3"
        />
        <div
          className="grid-x grid-margin-x"
          data-preview-id={!isSectionReference ? '#st_pictoItems' : undefined}
        >
          {items.map((item, index) => (
            <div
              className="large-3 medium-6 small-12 cell"
              key={key(item)}
              data-preview-id={!isSectionReference ? `#${index}` : undefined}
            >
              <PictoItem {...item} reducedMobileVersion={!!reducedMobileVersion} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
